import React from 'react'
import AboutUs from '../Components/AboutUs/AboutUs'

const About = () => {
  return (
    <div>
        <AboutUs/>
    </div>
  )
}

export default About